<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :title="`党建经费`"
        :visible.sync="dialogVisible"
        center
        width="700px">
        <div class="flex flex-direction">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form" label-width="auto">
                <el-form-item label="时间" prop="fundsTime">
                    <el-date-picker
                        v-model="ruleForm.fundsTime"
                        placeholder="选择日期"
                        type="date"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <el-radio-group v-model="ruleForm.type" @change="typeChange">
                        <el-radio :label="1">收入</el-radio>
                        <el-radio :label="0">支出</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="ruleForm.type === 1" ref="state" :rules="{required: true, message: `请选择经费名称`, trigger: 'blur'}" label="经费名称"
                              prop="state">
                    <el-select
                        v-model="ruleForm.state"
                        placeholder="请选择">
                        <el-option
                            v-for="(item,index) in expenditure_classify"
                            :key="index"
                            :label="item.label"
                            :value="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-else :rules="{required: true, message: `请输入经费名称`, trigger: 'blur'}" label="经费名称"
                              prop="state">
                    <el-input v-model="ruleForm.state" placeholder="请输入">
                    </el-input>
                </el-form-item>
                <el-form-item label="发生金额" prop="money">
                    <el-input v-model="ruleForm.money" placeholder="请输入" type="number">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="附件" prop="files">
                    <upload-file :files="ruleForm.files" multiple accept="image/*,application/pdf" type="files" @uploadFile="uploadFile"></upload-file>
                    <div class="text-red text-xs">注：要求：所上传凭必须有：1、联合党委书记，2、纪检委员，3、专职党务工作者，4、财务主管，5、出纳签字</div>
                </el-form-item>
                <el-form-item v-if="ruleForm.type === 1" label="备注" prop="remark">
                    <el-input v-model="ruleForm.remark" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入"
                              resize="none" type="textarea">
                    </el-input>
                </el-form-item>
                <el-form-item v-else label="经费说明" prop="typeMsg">
                    <el-radio-group v-model="ruleForm.typeMsg">
                        <el-radio v-for="(item,index) in expenditure_tips" :key="index" :label="item.label">
                            {{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button :loading="loading" @click="cancel">取消</el-button>
                    <el-button :loading="loading" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>

import {TOAST, toast, zhDate} from "@/utils/utils";
import UploadFile from "@/views/web/components/UploadFile";
import {expenditure_classify, expenditure_tips} from "@/utils/const";
import rules from "@/utils/rules";
import {addFunding, fundingDetail, fundingSave} from "@/api";

export default {
    name: "AddExpenditureDialog",
    components: {UploadFile},
    data() {
        return {
            expenditure_classify: expenditure_classify,
            expenditure_tips: expenditure_tips,
            ruleForm: {
                fundsTime: '',
                type: 1,
                state: expenditure_classify[0].label,
                money: '',
                files: [],
                remark: '',
                typeMsg: expenditure_tips[0].label
            },
            rules: {
                fundsTime: [
                    {required: true, message: '请选择日期', trigger: 'change'}
                ],
                money: [
                    {required: true, message: '请输入发生金额', trigger: 'change'},
                    rules.money
                ],
                remark: [
                    {required: true, message: '请输入备注', trigger: 'change'},
                ],
                file: [
                    {required: true, message: '请上传附件', trigger: 'change'},
                ]
            },
            loading: false
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        eid: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        if (this.eid) this.init()
    },
    methods: {
        async init() {
            let _data = await fundingDetail(this.eid)
            this.ruleForm.fundsTime = zhDate(_data.data.funding_time)
            this.ruleForm.type = _data.data.type
            this.ruleForm.state = _data.data.name
            this.ruleForm.money = _data.data.amount
            this.ruleForm.remark = _data.data.remark
            this.ruleForm.typeMsg = _data.data.content
            this.ruleForm.files = _data.data.file_url ? JSON.parse(_data.data.file_url) : []
        },
        cancel() {
            this.$refs.ruleForm.resetFields()
            this.$emit('watchState', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitItem()
                }
            });
        },
        async submitItem() {
            this.loading = false
            let _data = this.eid ? await fundingSave(this.eid, this.ruleForm.state,this.ruleForm.type, this.ruleForm.fundsTime,
                this.ruleForm.money,JSON.stringify(this.ruleForm.files), this.ruleForm.remark, this.ruleForm.typeMsg) :
                await addFunding(this.ruleForm.state,this.ruleForm.type, this.ruleForm.fundsTime,
                this.ruleForm.money,JSON.stringify(this.ruleForm.files), this.ruleForm.remark, this.ruleForm.typeMsg)
            this.loading = false
            if (_data.status === 200) {
                this.$refs.ruleForm.resetFields()
                toast('保存成功', TOAST.success)
                this.$emit('watchState', true)
            } else {
                toast(_data.info, TOAST.error)
            }
        },
        typeChange(e) {
            if (e === 1) {
                this.ruleForm.state = this.expenditure_classify[0].label
                this.ruleForm.typeMsg = ''
            } else {
                this.ruleForm.state = ''
                this.ruleForm.remark = ''
                this.ruleForm.typeMsg = this.expenditure_tips[0].label
            }
        },
        uploadFile(data) {
            if (data) {
                this.ruleForm.files = data.files
            }
        }
    },
    filters: {},
    watch: {
        eid() {
            if (this.eid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>

.info-container {
    height: 130px;
    background-color: #f4f4f4;
    border-radius: 10px;
    padding: 25px;

    .title {
        font-size: 16px;
        color: #333333;
    }

    .tips {
        font-size: 12px;
        color: #666666;
    }

    .submit {
        width: 200px;
        height: 42px;
        background: #023e96;
        color: #FFFFFF;
    }
}

</style>